import { render, staticRenderFns } from "./ActiveTrialsTableRow.vue?vue&type=template&id=2ee496c9&"
import script from "./ActiveTrialsTableRow.vue?vue&type=script&lang=js&"
export * from "./ActiveTrialsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports